import React from 'react'
import ProjectLayout from '../../components/projectLayout'
import data from '../../content/projects/internshipFinalReportPresentation'

export default function InternshipFinalReportPresentation() {
  return <ProjectLayout data={data} />
}
